export const accountantAccessInfoTooltip = "Accountant Access enables your team to view your client's Anchor account information, including invoices, agreements, and payments, as well as manage their payment methods.";
